import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime, stringAvatar} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {ContactPageVO, useQueryContactPage} from "@/service/contact.s";
import {WriteContact} from "@/pages/Contact/WriteContact";
import {Avatar, Box} from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import {ViewContact} from "@/pages/Contact/ViewContact";
import {permScope} from "@/helper/constant";
import {useAuthInfo} from "@/store/account.c";
import {useQueryPendingReview} from "@/service/instance.s";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import {ExecutePO, InstancePO} from "@/model/workflow";
import {CustomerPageVO} from "@/service/customer.s";
import {WriteInvoice} from "@/pages/Invoice/WriteInvoice";
import {WriteContract} from "@/pages/Contract/WriteContract";
import {WritePayback} from "@/pages/Payback/WritePayback";
import {WritePayment} from "@/pages/Payment/WritePayment";
import {WriteFieldwork} from "@/pages/Fieldwork/WriteFieldwork";
import {WriteLeave} from "@/pages/Leave/WriteLeave";
import {WriteExpense} from "@/pages/Expense/WriteExpense";
import {ViewContract} from "@/pages/Contract/ViewContract";
import {ViewPayback} from "@/pages/Payback/ViewPayback";
import {ViewInvoice} from "@/pages/Invoice/ViewInvoice";
import {ViewPayment} from "@/pages/Payment/ViewPayment";
import {ViewFieldwork} from "@/pages/Fieldwork/ViewFieldwork";
import {ViewLeave} from "@/pages/Leave/ViewLeave";
import {ViewExpense} from "@/pages/Expense/ViewExpense";

export const ApprovalListPage = () => {
    const {
        mutate: contactPageMutate,
        data: contactPageData,
        isPending: contactPagePending,
    } = useQueryPendingReview()
    const {role: {dataScope}} = useAuthInfo()

    const columns: GridColDef<InstancePO>[] = [
        {
            field: "title",
            headerName: "流程实例",
            flex: 0.8
        },
        {
            field: "classify",
            headerName: "流程分类",
            flex: 0.4,
            renderCell: ({row}) => <Chip label={row.classify} variant={'outlined'} color={'warning'}/>
        },
        {
            field: "nodeNames",
            headerName: "当前节点",
            headerAlign: "center",
            align: "center",
            flex: 0.5,
            valueFormatter: value => value || "-"
        },
        {
            field: "executes",
            headerName: "当前处理人",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
            display: 'flex',
            renderCell: ({row}) => {
                const executes: ExecutePO[] = row.executes || []
                return <Stack direction={'row'} spacing={1}>{executes?.map((execute: ExecutePO, index: number) => <Chip key={index} size={'small'}
                                                                                                                        label={execute?.propertyGroup?.map(propertyGroup => propertyGroup?.assigneeNames || '-')}></Chip>)}</Stack>
            }
        },
        {
            field: "urgeLastTime",
            headerName: "上次催办时间",
            headerAlign: "center",
            flex: 0.4,
            align: "center",
            valueFormatter: (value) => formatTime("D", value),
        },
        {
            field: "urgeCount",
            headerName: "催办次数",
            headerAlign: "center",
            align: "center",
            flex: 0.4
        },
        {
            field: "creator",
            headerName: "创建人",
            headerAlign: "center",
            align: "center",
            flex: 0.4,
            display: 'flex',
            renderCell: ({row}) => <Avatar {...stringAvatar(row.creator)} />
        },
        {
            field: "createdAt",
            headerName: "创建时间",
            headerAlign: "center",
            flex: 0.4,
            align: "center",
            valueFormatter: (value) => formatTime("D", value),
        },
    ];

    return (
        <ProTable<InstancePO>
            columnVisibilityModel={{seller: dataScope !== permScope['self']}}
            loading={contactPagePending}
            renderDrawer={{view: <ViewContact/>, write: <WriteContact/>}}
            columns={columns}
            data={contactPageData?.data}
            fieldKey={'businessId'}
            drawerProps={{
                view: {
                    hiddenFooter: true, viewBtnCallback: (row: InstancePO) => {
                        let updateForm: React.ReactNode
                        let viewDetail: React.ReactNode;

                        switch (row.classifyId) {
                            case 2:
                                updateForm = <WriteContract/>
                                viewDetail = <ViewContract mode={'drawer'}/>
                                break;
                            case 5:
                                updateForm = <WritePayback flag={1}/>
                                viewDetail = <ViewPayback flag={1} mode={'drawer'}/>
                                break
                            case 6:
                                updateForm = <WriteInvoice/>
                                viewDetail = <ViewInvoice mode={'drawer'}/>
                                break
                            case 8:
                                updateForm = <WritePayment/>
                                viewDetail = <ViewPayment mode={'drawer'}/>
                                break
                            case 9:
                                updateForm = <WriteFieldwork/>
                                viewDetail = <ViewFieldwork mode={'drawer'}/>
                                break
                            case 10:
                                updateForm = <WriteLeave/>
                                viewDetail = <ViewLeave/>
                                break
                            case 11:
                                updateForm = <WriteExpense/>
                                viewDetail = <ViewExpense/>
                                break
                        }

                        return {body: viewDetail, updateForm: updateForm, businessId: row.businessId, instanceId: row.id}
                    }
                }
            }}
            onSearch={(params) => {
                contactPageMutate(params);
            }}
            code={"approval"}
        />
    );
};
